(() => {
  if (customElements.get('puainta-home-video-gallery')) return;

  class PuaintaHomeVideoGallery extends HTMLElement {
    connectedCallback() {
      if (this.handleClick) return;

      this.handleClick = (event) => {
        const playButton = event.target.closest('[data-video-play]');
        if (!playButton || !this.contains(playButton)) return;

        const card = playButton.closest('[data-video-card]');
        if (card) this.play(card);
      };

      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (!this.handleClick) return;
      this.removeEventListener('click', this.handleClick);
      this.handleClick = null;
    }

    getYouTubeId(url) {
      try {
        const parsed = new URL(url, window.location.origin);
        const host = parsed.hostname.replace(/^www\./, '');
        if (host === 'youtu.be') return parsed.pathname.split('/').filter(Boolean)[0] || '';
        if (host.endsWith('youtube.com')) {
          if (parsed.pathname === '/watch') return parsed.searchParams.get('v') || '';
          const match = parsed.pathname.match(/^\/(?:shorts|embed)\/([^/?#]+)/);
          return match ? match[1] : '';
        }
      } catch (error) {
        return '';
      }
      return '';
    }

    getVimeoId(url) {
      try {
        const parsed = new URL(url, window.location.origin);
        const host = parsed.hostname.replace(/^www\./, '');
        if (!host.endsWith('vimeo.com')) return '';
        const matches = parsed.pathname.match(/\d+/g);
        return matches ? matches[matches.length - 1] : '';
      } catch (error) {
        return '';
      }
    }

    isMp4(url) {
      return /\.mp4(?:$|[?#])/i.test(url);
    }

    createUploadedPlayer(card) {
      const template = card.querySelector('[data-uploaded-video-template]');
      if (!template) return null;

      const sourceVideo = template.content.querySelector('video');
      if (!sourceVideo) return null;

      const video = sourceVideo.cloneNode(true);
      video.controls = true;
      video.playsInline = true;
      video.preload = 'metadata';
      return video;
    }

    createPlayer(url, title) {
      const youtubeId = this.getYouTubeId(url);
      if (youtubeId) {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1&rel=0`;
        iframe.title = title || 'Puainta customer video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        return iframe;
      }

      const vimeoId = this.getVimeoId(url);
      if (vimeoId) {
        const iframe = document.createElement('iframe');
        iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(vimeoId)}?autoplay=1`;
        iframe.title = title || 'Puainta customer video';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        return iframe;
      }

      if (this.isMp4(url)) {
        const video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('aria-label', title || 'Puainta customer video');
        return video;
      }

      return null;
    }

    stopAll(exceptCard = null) {
      const cards = Array.from(this.querySelectorAll('[data-video-card]'));
      cards.forEach((card) => {
        if (card === exceptCard) return;
        const player = card.querySelector('[data-video-player]');
        const video = player?.querySelector('video');
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
        }
        player?.replaceChildren();
        card.classList.remove('is-playing');
      });
    }

    play(card) {
      const media = card.querySelector('[data-video-media]');
      const playerContainer = card.querySelector('[data-video-player]');
      const url = media?.dataset.videoUrl?.trim() || '';
      const title = media?.dataset.videoTitle || '';
      if (!playerContainer) return;

      const player = this.createUploadedPlayer(card) || this.createPlayer(url, title);
      if (!player) return;

      this.stopAll(card);
      playerContainer.replaceChildren(player);
      card.classList.add('is-playing');

      if (player.tagName === 'VIDEO') {
        player.play().catch(() => {});
      }
    }
  }

  customElements.define('puainta-home-video-gallery', PuaintaHomeVideoGallery);
})();
